import type { ReduxRootState, RootState } from 'model/Redux';
import { createSelector, Selector } from 'reselect';

export const buyFromSellingOrderSelector: Selector<RootState, ReduxRootState> = (state: RootState) => state.buyFromBestSellingOrder;
export const buyFromSellingOrderLoadingSelector = createSelector<RootState, ReduxRootState, boolean>(
    buyFromSellingOrderSelector,
    state => state.loading 
);